var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"card-list-item__user-icons-icon",attrs:{"href":`/users/${_vm.user_id}`}},[_c('img',{staticClass:"a-user-icon",attrs:{"src":_vm.comment.user_icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }